export const FirebaseConfig = {
	"projectId": "quickcab-ab15c",
	"appId": "1:402824504928:web:2789c7cde6071211e20505",
	"databaseURL": "https://quickcab-ab15c-default-rtdb.europe-west1.firebasedatabase.app",
	"storageBucket": "quickcab-ab15c.firebasestorage.app",
	"apiKey": "AIzaSyBW4Xyez-d0TngWHEs72UVmipgfvpKWpKY",
	"authDomain": "quickcab-ab15c.firebaseapp.com",
	"messagingSenderId": "402824504928",
	"measurementId": "G-QSE4CRD8TJ"
};